import { defineMessages } from 'react-intl';

export const betaScope = 'app.components.globalNav.analyticsBetaNavLink';

export default defineMessages({
  analyticsBeta: {
    id: `${betaScope}.analyticsBeta`,
    defaultMessage: 'Analytics (beta)',
  },
});
